function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isServerSide as l } from "./environment.js";
const u = (e)=>{
    if (l()) return !1;
    const n = document.createElement("input");
    return n.setAttribute("type", e), n.type === e;
}, v = (e)=>{
    e.stopPropagation(), e.preventDefault();
}, d = (e, n)=>{
    const t = new Event("change");
    return e.value = n, _objectSpreadProps(_objectSpread({}, t), {
        target: e,
        currentTarget: e
    });
};
let i = !1;
try {
    const e = Object.defineProperty({}, "passive", {
        get () {
            i = !0;
        }
    });
    window.addEventListener("test", ()=>{}, e);
} catch (e1) {}
const p = (e, n, t)=>e.addEventListener(n, t, i ? {
        passive: !0
    } : !1), f = (e, n, t)=>e.removeEventListener(n, t, !1), m = (e, n)=>{
    const t = n ? {
        "data-component-name": n
    } : {};
    return e && Object.keys(e).forEach((r)=>{
        t["data-" + r] = e[r];
    }), t;
}, c = (e, n)=>{
    const t = `overflow${n}`, r = window.getComputedStyle(e)[t];
    return [
        "auto",
        "scroll",
        "overlay"
    ].includes(r);
}, w = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Y";
    let t = e == null ? void 0 : e.parentElement;
    for(; t && !c(t, n);)t = t.parentElement;
    return t || document.documentElement;
}, E = (e)=>e.scrollHeight - e.scrollTop - e.clientHeight, g = (e)=>e.scrollHeight > e.clientHeight, h = (e, n)=>{
    const t = ()=>typeof window > "u" ? Promise.resolve(null) : window.ResizeObserver ? Promise.resolve(ResizeObserver) : import(/* webpackChunkName: "@juggle/resize-observer" */ "@juggle/resize-observer").then((o)=>o.ResizeObserver);
    let r = !1, s = null;
    return t().then((o)=>{
        !r && o && (s = new o(n), s.observe(e));
    }), ()=>{
        r = !0, s && s.disconnect();
    };
};
export { p as addPassiveEventListener, v as cancelEvent, d as createChangeEvent, m as getPrefixedDataAttributes, E as getScrollDistanceToBottom, w as getScrollableParentElement, g as hasScroll, u as isInputTypeSupported, h as listenResize, f as removePassiveEventListener };
